(ns app.team.register
  "UI register entries for the team slice."
  (:require [app.team.add-user :as add-user]
            [app.team.page :as page]))

(def register
  [add-user/page
   page/page])
